import React from "react";
import clsx from "clsx";

import styles from "./layout.module.scss";

type TableContainerProps = {
	className?: string;
	tableHeight?: string;
	style?: React.CSSProperties;
	children: any;
};

export const TableContainer = ({
	className,
	tableHeight,
	style,
	children,
}: TableContainerProps) => {
	// Remove after implementing new filters
	const height = tableHeight && `calc(100vh - ${tableHeight})`;

	return (
		<div
			className={clsx(styles.tableContainer, className)}
			style={{ ...style, height, minHeight: height }}
		>
			{children}
		</div>
	);
};
